import {BrandliftBox} from 'client/common/types';

export function transformLegacyBrandliftBox(box: BrandliftBox) {
    if (box.context.customMetrics || !box.customMetrics) {
        return box;
    }

    box.context.customMetrics = ['brandAwareness', 'adRecall', box.customMetrics];

    return box;
}
